import React from 'react';
export function Footer() {
  return <footer className="py-6 md:py-8 text-xs md:text-sm text-gray-500" data-id="element-17">
      <div className="border-t border-gray-200 pt-6 md:pt-8 mb-4 md:mb-6" data-id="element-18">
        <p className="mb-3 md:mb-4 italic" data-id="element-19">
          Disclaimer: This information is for educational purposes only and has
          not been evaluated by the FDA. Vascura Cayenne Drops is not intended
          to diagnose, treat, cure, or prevent any disease. Individual results
          may vary. Always consult with a healthcare provider before starting
          any new supplement.
        </p>
        <p data-id="element-20">© 2025 Health & Vitality Journal. All Rights Reserved.</p>
      </div>
    </footer>;
}